let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jnw0A")).then(() => parcelRequire('l4mr2'));